import React, { useEffect, useState } from "react";
import { NewMap } from '@synergy/maps';
import styled from "styled-components";
import i18next from "i18next";
import { Flex } from "antd";
// import logger from "../../../server/logger";
import { containerMiddlewareAdEPorto } from "../../../../server/constants.api";
import { NoData } from "../../Atomics/NoData";
import { useGlobalFilterContext } from "../../../../contexts/GlobalFilterProvider";
import Spinner from "../../Atomics/Spinner";
import useFetch from "../../../../server/useFetch";
import { useTranslation } from "react-i18next";
import { REACT_APP_MAPS_API_KEY } from "../../../../utils/config/envConfig";

// Component for displaying events on a map
export const EventsMapComponent = ({ tenantId, classes, mapShowInfo, yearToFetch }) => {
  const { t } = useTranslation();
  const [pois, setPois] = useState();
  const [mapConfigurations, setMapConfigurations] = useState(null);
  const { isToApplyFilters, setIsToApplyFilters, entityToFetch } = useGlobalFilterContext();

  const { data: eventsMaps, isFetching: eventsMapsIsFetching, refetch: refetchEventsMaps } = useFetch(
    "events/maps", "eventsMaps",
    {
      id: tenantId,
      classes: classes?.join(), //Para enviar mais que uma enviar com ; (ex. Office;Lab)
      startDate: `${yearToFetch}-01-01T00:00:00`,
      endDate: `${yearToFetch}-12-31T23:59:59`,
    },
    false, null, containerMiddlewareAdEPorto);

  useEffect(() => {
    if (eventsMaps && entityToFetch) {
      const copyConfigurations = defaultMapConfigurations(t);
      const configurationsCopy = {
        ...copyConfigurations,
        lat: Number(entityToFetch.cordinates.latitude),//38.71956666763748
        lng: Number(entityToFetch.cordinates.longitude),//-9.137763909977604
        // zoom: city?.zoom
      };
      setMapConfigurations(configurationsCopy);
      if (mapShowInfo) {
        setPois(eventsMaps?.data);
      } else {
        setPois(eventsMaps?.data.filter(poi => !(poi.priority && poi.priority.toUpperCase() === 'INFO')));
      }
    }
  }, [eventsMaps]);

  useEffect(() => {
    if (eventsMaps && entityToFetch) {
      if (mapShowInfo) {
        setPois(eventsMaps?.data);
      } else {
        setPois(eventsMaps?.data.filter(poi => !poi.priority?.includes('INFO')));
      }
    }
  }, [mapShowInfo]);

  useEffect(() => {
    if (isToApplyFilters) {
      refetchEventsMaps();
    }
  }, [isToApplyFilters]);

  useEffect(() => {
    refetchEventsMaps();
  }, [yearToFetch]);

  // Effect to refetch map configurations data when language changes
  useEffect(() => {
    try {
      // refetchMapConfigurationsData();
    } catch (error) {
      console.error('(EventsMapComponent page) Error in useEffect refecthing map configurations data:', error);
      //reportError(error); // Send error report to backend
    }
  }, [i18next.resolvedLanguage])

  return (
    <MapWrapper>
      {!eventsMapsIsFetching ?
        <>
          {pois?.length > 0 ?
            <NewMap configurations={mapConfigurations}
              pois={pois.map(poi => { return { ...poi, priority: getPriorityLevel(poi.priority), name: poi.description, translatedClass: t(poi.class) } })}
              onMarkerClick={() => console.log('CLiked')} apiKey={REACT_APP_MAPS_API_KEY} />
            : <NoData />}
        </>

        : <Flex align="center" justify="center" className="full-h"><Spinner stroke="green-4" /></Flex>}
    </MapWrapper>
  )
}

// Styled component for wrapping the map
const MapWrapper = styled.div`
    height: 400px;
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;

function defaultMapConfigurations(t) {
  return {
    "heading": 0,
    "hide": [
      "attraction",
      "sports_complex",
      "place_of_worship",
      "business",
      "government",
      "medical",
      "park",
      "school"
    ],
    "mapId": "15fb961c1d0a757",
    "showGTFSRealTime": false,
    "showPOIS": true,
    "showTraffic": false,
    "showTransit": false,
    "showPolygon": false,
    "showEvents": false,
    "styles": "default",
    "tilt": 0,
    "zoom": 12,
    "hrefLink": "/home/register/registerDetail/",
    "poiType": "pois-color-by-family",
    "showLegend": false,
    "legendArray": [{
      label: t('Buildings'),
      color: 'color1-medium',
      typoligies: [{
        label: t('School'),
        icon: "School",
      }, {
        label: t('Social'),
        icon: "SocialHousing",
      }, {
        label: t('Cultural Spaces'),
        icon: "CulturalSpaces",
      }, {
        label: t('Pavilion'), //Pavilhão
        icon: "SportIndoor",
      }, {
        label: t('Comercial'),
        icon: "Euro",
      }, {
        label: t('Civil Protection'),
        icon: "CivilProtection",
      }, {
        label: t('Sports'),
        icon: "Gym",
      }, {
        label: t('Others'),
        icon: "Marker",
      }, {
        label: t('Administrative'),
        icon: "Clipboard",
      },
      {
        label: t('Storage'),
        icon: "Storage",
      },
      {
        label: t('Social Housing'),
        icon: "SocialHousing",
      },
      {
        label: t('Health'),
        icon: "Health",
      },
      {
        label: t('events'),
        icon: "Cone",
      }
      ]
    },
    {
      label: t('Infrastructures'),
      color: 'color2-medium',
      typoligies: [{
        label: t('Parking Lot'),
        icon: "ParkingLot",
      },
      {
        label: t('Graveyard'),
        icon: "Graveyard",
      },
      {
        label: t('Advertising Panels'),
        icon: "AdvertisingPanels",
      },
      // {
      //   label: 'Waste Water Treatment',
      //   icon: "WasteWaterTreatment",
      // },
      {
        label: t('Sanitary waste water collection'),
        icon: "SanitaryWasteWaterCollection",
      },
      // {
      //   label: 'Recycled Waste Collection',
      //   icon: "SolidWaste",
      // },
      {
        label: t('Domestic Waste Collection'),
        icon: "HouseholdWasteCollection",
      },
      {
        label: t('Energy Production'),
        icon: "EnergyProduction",
      },
      {
        label: t('Tunnel'),
        icon: "Tunnel",
      },
      // {
      //   label: 'Irrigation System',
      //   icon: "",
      // },
      {
        label: t('Public Space'),
        icon: "PublicSpaces",
      },
      {
        label: t('Monument'),
        icon: "Monument",
      },
      {
        label: t('Distribution Network'),
        icon: "DistributionNetwork",
      },
      // {
      //   label: 'Distribution Transformer Station',
      //   icon: "",
      // },
      // {
      //   label: 'Electricity Meter',
      //   icon: "ElectricityMeter",
      // },
      // {
      //   label: 'Gas Meter',
      //   icon: "GasMeter",
      // },
      {
        label: t('Electric Vehicle Charging Station'),
        icon: "ElectricStation",
      },
      {
        label: t('Water Supply'),
        icon: "WaterDrop",
      },
      // {
      //   label: 'Water Treatment',
      //   icon: "WasteWaterTreatment",
      // },
      {
        label: t('Traffic Light'),
        icon: "TrafficLight",
      },
      {
        label: t('Road Segment'),
        icon: "Road",
      }
      ]
    },
    {
      label: t('Street Lighting'),
      color: 'color3-medium',
      typoligies: [{
        label: t('Street Lighting'),
        icon: "StreetLight",
      }]
    },
      // { label: 'Provisional', color: 'color5-medium' },
    ],
    "legendDetail": true,
    "hideEventsInfo": false,
    "circleRadius": null
  }
};

const getPriorityLevel = (priority) => {
  switch (priority) {
    case 'CRITICAL':
      return '1';
    case 'HIGH':
      return '2';
    case 'MEDIUM':
      return '3';
    case 'LOW':
      return '4';
    default:
      return '5';
  }
};